export interface FormatPriceOptions {
  currencySymbol?: string;
  locale?: string;
  fractionDigits?: number;
}

/**
 * Format a price amount stored in cents.
 * Defaults match the legacy behavior: "$" symbol + "zh-HK" locale.
 */
export function formatPrice(
  price: number | undefined | null,
  options: FormatPriceOptions = {}
): string {
  const {
    currencySymbol = '$',
    locale = 'zh-HK',
    fractionDigits = 2,
  } = options;

  if (price === undefined || price === null || Number.isNaN(price)) {
    return `${currencySymbol}0`;
  }

  const amount = price / 100;
  const formatted = amount.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits,
  });

  return `${currencySymbol}${formatted}`;
}

export default formatPrice;
